import SectionHeading from "./SectionHeading";
import { guideSteps } from "@/mocks/anime";

export default function GuideSection() {
  return (
    <section id="guide" className="w-full bg-background-100 px-4 py-14 md:px-8 md:py-20">
      <SectionHeading
        eyebrow="第一次来这样用"
        title="新手追番指南"
        desc="不用记住所有入口，按下面的顺序走一遍，基本就能建立属于自己的追番与补番节奏。每一步都只用到本页已有的功能。"
      />

      <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {guideSteps.map((step, index) => (
          <div key={step.step} className="relative flex flex-col rounded-lg border border-background-200 bg-background-50 p-5">
            <div className="flex items-center justify-between">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-500 text-accent-950">
                <i className={`${step.icon} text-xl`} />
              </span>
              <span className="font-heading text-4xl text-background-300">{step.step}</span>
            </div>
            <h3 className="mt-4 font-heading text-xl text-foreground-950">{step.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
            {index < guideSteps.length - 1 && (
              <i className="ri-arrow-right-line absolute -right-3 top-1/2 hidden -translate-y-1/2 text-background-400 lg:block" />
            )}
          </div>
        ))}
      </div>
    </section>
  );
}